// extracted by mini-css-extract-plugin
module.exports = {"section":"_w9-lM","title":"_16fXB","article":"_3EYNo","member":"_2P1Dj","cover":"_3YVBd","name":"_1GZrv","description":"_2p92k"};